import React from 'react'

const NoResultsIcon = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="50" cy="29" r="1.6" fill="#151B56" />
    <circle cx="62" cy="33" r="1.1" fill="#151B56" />
    <circle cx="55" cy="11" r="0.8" fill="#151B56" />
    <circle cx="70" cy="22" r="0.55" fill="#151B56" />
    <g>
      <circle cx="50" cy="50" r="35" fill="#EAEFFF" stroke="#DAE5FF" strokeWidth="0.8" />
      <circle cx="50" cy="50" r="35" fill="url(#noResultsInsetShadow)" />
    </g>
    <g transform="translate(34, 34)">
      <g transform="rotate(-30 16 16)">
        <rect x="2" y="14" width="20" height="6.5" rx="1.6" fill="#151B56" />
        <circle cx="22.5" cy="17.25" r="3.4" fill="#151B56" />
        <rect x="2.5" y="13.6" width="2.4" height="7.3" rx="0.6" fill="#1948D2" />
      </g>
      <rect x="14.6" y="20.5" width="3" height="6.4" fill="#151B56" />
      <rect x="9.6" y="26" width="13" height="2.6" rx="1" fill="#151B56" />
    </g>
    <path
      d="M70 21 L71.6 25 L75.6 26.6 L71.6 28.2 L70 32.2 L68.4 28.2 L64.4 26.6 L68.4 25 Z"
      fill="#151B56"
    />
    <path
      d="M82 36 L82.9 38 L84.9 38.9 L82.9 39.8 L82 41.8 L81.1 39.8 L79.1 38.9 L81.1 38 Z"
      fill="#151B56"
    />
    <path
      d="M77 13 L77.5 14.2 L78.7 14.7 L77.5 15.2 L77 16.4 L76.5 15.2 L75.3 14.7 L76.5 14.2 Z"
      fill="#151B56"
    />
    <defs>
      <radialGradient
        id="noResultsInsetShadow"
        cx="0.5"
        cy="0"
        r="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0.7" stopColor="#DAE5FF" stopOpacity="0" />
        <stop offset="1" stopColor="#DAE5FF" stopOpacity="0.7" />
      </radialGradient>
    </defs>
  </svg>
)

export default NoResultsIcon
